import { paginatorRoute } from '@api/paginator';
import { authContext } from '@staffedupusa/shared-components';
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useQuery } from 'react-query';

import {
  getThreadRoute,
  messagesKey,
  errorMessage,
  Thread,
  Message,
} from '@features/messaging';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseThreadProps = {
  applicantId?: number;
  threadId?: number;
  companyId?: number;
  setErrorText?: Dispatch<SetStateAction<string>>;
  threadPage?: number;
};

export const useGetEnterpriseThread = ({
  applicantId,
  threadId,
  companyId,
  setErrorText = () => { },
  threadPage = 1,
}: useGetEnterpriseThreadProps): {
  messages: Message[] | undefined;
  thread: Thread | null;
  isLoadingThread: boolean;
} => {
  const [thread, setThread] = useState<Thread | null>(null);
  const [stateThreadId, setStateThreadId] = useState<number | undefined>(
    threadId,
  );
  const [messages, setMessages] = useState<Message[]>([]);

  const { isLoading: isLoadingThread } = useQuery({
    queryKey: [messagesKey, stateThreadId, companyId, threadPage],
    enabled: Boolean(threadId || applicantId),
    queryFn: () => {
      const params = new URLSearchParams();

      // if (threadPage > 1) {
      params.append('page', String(threadPage));
      // params.append('cache', 'messages');
      // }

      stateThreadId && params.append('thread_id', String(stateThreadId));
      params.append('company_id', String(companyId));
      params.append('applicant_id', String(applicantId));

      const requestUrl = getThreadRoute;
      return axiosInstance.get(requestUrl, { params }).then((res) => res.data);
    },

    onSuccess: (data) => {
      if (data.object2) {
        setErrorText('');
        setStateThreadId(data.object2?.id);
        setThread(data.object2);
      }
      if (data.status === 205) {
      } else {
        if (data?.object?.length && threadPage > 1) {
           setMessages((prev) => {
            const newMessages = (data.object as Message[]).filter(
              (newMessage) =>
                !prev.some((prevMessage) => prevMessage.id === newMessage.id),
            );
            return [...prev, ...newMessages];
          });
        } else {
          setMessages(data.object as Message[]);
        }
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchInterval: 5000,
  });

  useEffect(() => {
    setStateThreadId(undefined);
  }, [applicantId]);

  useEffect(() => {
    setStateThreadId(threadId);
  }, [threadId]);

  useEffect(() => {
    if (threadPage === 1) {
      setMessages([]);
    }
  }, [threadPage]);

  return {
    isLoadingThread,
    thread,
    messages: messages && messages.sort(
      (a, b) =>
        new Date(a.dt_timestamp).getTime() - new Date(b.dt_timestamp).getTime(),
    ),
  };
};
